<script>
  export let size = 20;
  export let className = "";
  export let thickness = 2;
  export let speed = 1.5;
  export let color = "#000000";

  // Generate unique ID for this component instance
  const uniqueId = `clip-loader-${Math.random().toString(36).substr(2, 9)}`;
</script>

<svelte:head>
  <style>
    @keyframes clip-loader-spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  </style>
</svelte:head>

<div
  class="clip-loader-wrapper {className}"
  style="
    position: relative;
    width: {size}px;
    height: {size}px;
    color: {color};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  "
>
  <div
    class="clip-loader-spinner"
    style="
      position: absolute;
      width: 100%;
      height: 100%;
      border-style: solid;
      border-width: {thickness}px;
      border-color: rgba(0, 0, 0, 0.1);
      border-top-color: {color};
      border-radius: 50%;
      animation: clip-loader-spin {speed}s linear infinite;
    "
  />
</div>
